import { COUNT_NOTIFICATION, NOTIFICATION_LIST, READ_NOTIFICATION, FRND_NOTIFICATION_LIST } from './constants';
import { getAuthHeader } from "../helpers/authHelper";
import { getReq , putReq, postReq} from './rest';
import { handleResponse, loader } from './utils';


export const notificationCounter = (notificationCounter) => {
    return {
      type: COUNT_NOTIFICATION,
      notificationCounter
    };  
};

export const getNotificationCount = (params) => {
    return (dispatch, getState) => {
      const bodyFormData = new FormData();
      const {login} = getState();
      bodyFormData.set('user_id', login.user.id);
      bodyFormData.set('chat_counter', 1);
      const headers = getAuthHeader();
      postReq(`${apiURLPrefix}/userfeed/notification_counter`, bodyFormData , headers)
      .then(handleResponse) 
      .then((res) => {
        dispatch(notificationCounter(res));
      }).catch((err)=>{
        console.log(err);
      }) 
    }
}


export const notificationList = (notificationList) => {
  return {
    type: NOTIFICATION_LIST,
    notificationList
  };  
};

export const getNotificationlist = (pagination) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('user_id', login.user.id);
    bodyFormData.set('pagination', pagination);
    const headers = getAuthHeader();
  
    postReq(`${apiURLPrefix}/userfeed/notification`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      dispatch(notificationList(res));
    }).catch((err)=>{
      console.log(err);
    }) 
  }
}

export const readNotification = (readNotification) => {
  return {
    type: READ_NOTIFICATION,
    readNotification
  };  
};

export const updateReadNotification = (param) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    bodyFormData.set('notification_id', param.id);
    const headers = getAuthHeader();
  
    postReq(`${apiURLPrefix}/userfeed/viewnotification`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      dispatch(readNotification(param));
    }).catch((err)=>{
      console.log(err);
    }) 
  }
}

export const friendnotificationList = (friendnotificationList) => {
  return {
    type: FRND_NOTIFICATION_LIST,
    friendnotificationList
  };  
};

export const getFriendNotificationlist = (pagination) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('user_id', login.user.id);
    bodyFormData.set('pagination', pagination);
    const headers = getAuthHeader();
  
    postReq(`${apiURLPrefix}/userfeed/notificationfriend`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      dispatch(friendnotificationList(res));
    }).catch((err)=>{
      console.log(err);
    }) 
  }
}
